let state = {
  status: 'idle', // idle | running | success | error
  data: null,
  error: null,
};

let activePromise = null;
const listeners = new Set();

function emit() {
  const snapshot = { ...state };
  listeners.forEach((cb) => {
    try {
      cb(snapshot);
    } catch (_) {
      // ignore subscriber errors
    }
  });
}

export function getTryonGenerationState() {
  return { ...state };
}

export function subscribeTryonGeneration(cb) {
  listeners.add(cb);
  cb({ ...state });
  return () => listeners.delete(cb);
}

export function consumeTryonGenerationResult() {
  if (state.status !== 'success' || !state.data) return null;
  const out = state.data;
  state = { status: 'idle', data: null, error: null };
  emit();
  return out;
}

export function startTryonGeneration(runRequest) {
  if (state.status === 'running' && activePromise) return activePromise;

  state = { status: 'running', data: null, error: null };
  emit();

  activePromise = Promise.resolve()
    .then(() => runRequest())
    .then((data) => {
      state = { status: 'success', data, error: null };
      activePromise = null;
      emit();
      return data;
    })
    .catch((err) => {
      state = { status: 'error', data: null, error: err };
      activePromise = null;
      emit();
      throw err;
    });

  return activePromise;
}
